import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  return (
    <>
      <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${menuOpen ? 'menu-open' : ''}`}>
        <a href="#hero" className="nav-logo" onClick={() => setMenuOpen(false)}>
          <div className="logo-icon">
            <img src={process.env.PUBLIC_URL + '/logo.png'} alt="TIGOO Logo" />
          </div>
          TIGOO
        </a>

        <button
          className={`menu-toggle ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className="nav-links nav-desktop">
          <li><a href="#hero">Accueil</a></li>
          <li><a href="#features">Fonctionnalites</a></li>
          <li><a href="#how-it-works">Comment ça marche</a></li>
          <li><a href="#testimonials">Témoignages</a></li>
          <li><a href="#faq">FAQ</a></li>
          <li><a href="#cta" className="nav-cta">Accéder à l'app</a></li>
        </ul>
      </nav>

      <div className={`mobile-menu-overlay ${menuOpen ? 'active' : ''}`}>
        <ul className="mobile-menu-links">
          <li><a href="#hero" onClick={() => setMenuOpen(false)}>Accueil</a></li>
          <li><a href="#features" onClick={() => setMenuOpen(false)}>Fonctionnalites</a></li>
          <li><a href="#how-it-works" onClick={() => setMenuOpen(false)}>Comment ça marche</a></li>
          <li><a href="#testimonials" onClick={() => setMenuOpen(false)}>Témoignages</a></li>
          <li><a href="#faq" onClick={() => setMenuOpen(false)}>FAQ</a></li>
          <li className="mobile-cta-li">
            <a href="#cta" className="nav-cta mobile-cta" onClick={() => setMenuOpen(false)}>Accéder à l'app</a>
          </li>
        </ul>
      </div>
    </>
  );
}
